<!--
  Image centred with no text wrap. See ImageAlignLeftIcon for the shared geometry
  and why the text bars sit above and below rather than beside; only the tile's x
  origin differs (6.5 here).
-->
<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width="100%"
    height="100%"
    fill="currentColor"
    aria-hidden="true"
  >
    <rect x="2" y="2.5" width="20" height="1.6" rx="0.8" opacity="0.5" />
    <path
      fill-rule="evenodd"
      d="M8 6.5h8a1.5 1.5 0 0 1 1.5 1.5v8a1.5 1.5 0 0 1-1.5 1.5H8A1.5 1.5 0 0 1 6.5 16V8A1.5 1.5 0 0 1 8 6.5Z
         M8.1 16 L11 11.6 L12.8 14.2 L13.9 12.9 L15.9 16 Z"
    />
    <rect x="2" y="19.9" width="20" height="1.6" rx="0.8" opacity="0.5" />
  </svg>
</template>

<script>
export default {
  name: 'ImageAlignCenterIcon'
};
</script>
